var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 17.51V11.5C16 10.95 15.55 10.5 15 10.5C14.45 10.5 14 10.95 14 11.5V17.51H12.21C11.76 17.51 11.54 18.05 11.86 18.36L14.65 21.14C14.85 21.33 15.16 21.33 15.36 21.14L18.15 18.36C18.47 18.05 18.24 17.51 17.8 17.51H16ZM8.65003 3.85002L5.86003 6.64002C5.54003 6.95002 5.76003 7.49002 6.21003 7.49002H8.00003V13.5C8.00003 14.05 8.45003 14.5 9.00003 14.5C9.55003 14.5 10 14.05 10 13.5V7.49002H11.79C12.24 7.49002 12.46 6.95002 12.14 6.64002L9.35003 3.85002C9.16003 3.66002 8.84003 3.66002 8.65003 3.85002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpdown);
export default __webpack_public_path__ + "static/media/ic_updown.352eae04a2f47469adc97414e16ac1e8.svg";
export { ForwardRef as ReactComponent };